// TODO(phase-1-publish): replace OWNER with the real GitHub owner before the repo goes public.
// Tracked as RESEARCH Open Question #2; final URL is a one-line edit before launch.
export const REPO_URL = 'https://github.com/OWNER/roomdrop';
